// extracted by mini-css-extract-plugin
export var footer = "_nq-5";
export var fulfillmentInput = "_nq-0";
export var shipDateInput = "_nq-1";
export var shipmentModal = "_nq-2";
export var shipmentModalContent = "_nq-3";
export var tableContainer = "_nq-4";